import axios from 'axios';
import { useEffect, useState } from 'react';
import { TokenAccessor } from '../../types/API';
import LoadingState from '../../../LoadingState';
import { ExerciseLoading, LoadingText } from '../exercise-manager/components/exercise-loading';

type Props = {
  iframeTitle: string;
  loginUrl: string;
  tokenAccessor: TokenAccessor;
  studioGroup: string;
  width?: string;
  height?: string;
  loadingText?: LoadingText;
};

export function LtiViewer({
  iframeTitle,
  loginUrl,
  tokenAccessor,
  studioGroup,
  width = '100%',
  height = '100%',
  loadingText,
}: Props): JSX.Element | null {
  const [ltiLaunchUrl, setLtiLaunchUrl] = useState<string>();

  useEffect(() => {
    async function startLtiLaunch(loginUrl: string): Promise<void> {
      const accessToken = await tokenAccessor.tokenGetter();
      const res = await axios.get<{ url: string }>(loginUrl, {
        headers: { Authorization: `Bearer ${accessToken}`, studioGroup },
      });
      setLtiLaunchUrl(res.data.url);
    }

    startLtiLaunch(loginUrl);
  }, [loginUrl, studioGroup, tokenAccessor]);

  if (!ltiLaunchUrl) {
    return loadingText ? (
      <ExerciseLoading loadingText={loadingText} />
    ) : (
      <LoadingState variant="list" aria-label="loading" size={30} inMain={false} />
    );
  }

  return (
    <iframe
      role="application"
      width={width}
      height={height}
      title={iframeTitle}
      src={ltiLaunchUrl}
      frameBorder="0"
      allowFullScreen
    />
  );
}
